import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useParams, Link } from "react-router-dom";
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from '../../lib/isEmpty';
import {MatEditor} from "maticzeditor"
import { getfaq, updatefaq } from '../../actions/users';
import { useNavigate } from 'react-router-dom';

const initialFormValue = {
    'question': "",
    'answer': "",
}

const FAQEdit = () => {
    const navigate = useNavigate()
    const [userdet, setUser] = useState();
    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const { faqId } = useParams();
    const [question, setquestion] = useState("");
    const [answer, setanswer] = useState("");
    const onChange = (e) => {
    setquestion(e.target.value)
  }
  const onEditorChange = (evt) => {
    var description_text = evt
    setanswer(description_text);
  }
  

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let reqData = {
        question,
        answer,
        faqId
    }
    let { error } = await updatefaq(reqData);
    if (isEmpty(error)) {
     toastAlert("success", 'Faq updated successfully');
     navigate('/faqlist')
    } else {
      setValidateError(error);
    }
  }
    useEffect(() => {
        getFaqData();
    }, [])

    const getFaqData = async () => {
        var test = await getfaq(faqId);
        if(test.Success){
          if(test.userValue.question){
        setquestion(test.userValue.question)
      }
        if(test.userValue.answer){
        setanswer(test.userValue.answer)
      }
       }
    }

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Edit FAQ'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                        <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>

                            <form noValidate onSubmit={handleFormSubmit}>
                            <div className="addcategorys">
                                    <h4>Edit Faq</h4>
                                    <p className='mb-0'>Update Faq</p>
                                </div>


                                <div className="categorylisdt">
                                <div className='row'>
                                <div className='col-xl-7 mt-3'>
                                        <label className='mb-2'>Question</label>
                                        <input
                                        className='form-control'
                                            type="text"
                                            id="question"
                                            value={question || ''}
                                            onChange={onChange}
                                            fullWidth
                                        />
                                        {validateError.question && (
                                            <span className="text-danger">{validateError.question}</span>
                                        )}
                                    </div>
                               
                               
                                    <div className='col-xl-7 mt-3'>
                                        <label className='mb-2'>Answer</label>
                                        <MatEditor sendata={answer} outdata={(evt) => onEditorChange(evt)} />
                                        {validateError.answer && (
                                            <span className="text-danger">{validateError.answer}</span>
                                        )}
                                    </div>
                                
                                </div>
                                </div>
                                <div>
                                    <button className='btn addcate mt-3 mb-4 ms-2' type="submit">Update</button>
                                </div>
                            </form>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default FAQEdit